import { h } from '@stencil/core';

const Icon = ({ width = '20px', height = '20px' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#379302" />
      <path
        d="M8.58518 12.1337L6.11984 9.64824C5.91081 9.4375 5.57254 9.43814 5.36428 9.64965C5.15602 9.86117 5.15665 10.2035 5.36568 10.4142L8.20809 13.2798C8.41657 13.49 8.75377 13.49 8.96225 13.2798L14.9355 7.25797C15.1445 7.04723 15.1452 6.70493 14.9369 6.49341C14.7287 6.28189 14.3904 6.28125 14.1814 6.49198L8.58518 12.1337Z"
        fill="#F8F8F8"
      />
    </svg>
  );
};

export default Icon;
